import _noop from "lodash/noop";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _indexOfInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/index-of";

/* eslint-disable max-len */

/* eslint-disable react/no-did-update-set-state */
import React from 'react';
import PropTypes from 'prop-types';
import { format as dateFnsFormat } from 'date-fns';
import BaseComponent from '../_base/baseComponent';
import { strings } from '@douyinfe/semi-foundation/lib/es/timePicker/constants';
import ScrollList from '../scrollList/index';
import ScrollItem from '../scrollList/scrollItem';
import ComboboxFoundation, { formatOption } from '@douyinfe/semi-foundation/lib/es/timePicker/ComboxFoundation';
import LocaleConsumer from '../locale/localeConsumer';

class Combobox extends BaseComponent {
  constructor(props) {
    super(props);

    this.cacheRefCurrent = (key, current) => {
      if (key && typeof key === 'string') {
        this.adapter.setCache(key, current);
      }
    };

    this.reselect = () => {
      const currentKeys = ['ampm', 'hour', 'minute', 'second'];

      _forEachInstanceProperty(currentKeys).call(currentKeys, key => {
        const current = this.adapter.getCache(key);

        if (current && current.scrollToIndex) {
          current.scrollToIndex();
        }
      });
    };

    this.onItemChange = _ref => {
      let {
        type,
        value,
        disabled
      } = _ref;
      // eslint-disable-next-line prefer-const
      let {
        onChange,
        use12Hours,
        isAM,
        format,
        timeStampValue
      } = this.props;
      const transformValue = this.foundation.getDisplayDateFromTimeStamp(timeStampValue); // TODO: foundation

      if (type === 'hour') {
        if (use12Hours) {
          if (isAM) {
            transformValue.setHours(Number(value) % 12);
          } else {
            transformValue.setHours(Number(value) % 12 + 12);
          }
        } else {
          transformValue.setHours(Number(value));
        }
      } else if (type === 'minute') {
        transformValue.setMinutes(Number(value));
      } else if (type === 'ampm') {
        const ampm = value.toUpperCase();

        if (use12Hours) {
          if (ampm === 'PM') {
            isAM = false;
            transformValue.getHours() < 12 && transformValue.setHours(transformValue.getHours() % 12 + 12);
          }

          if (ampm === 'AM') {
            isAM = true;
            transformValue.getHours() >= 12 && transformValue.setHours(transformValue.getHours() - 12);
          }
        }
      } else {
        transformValue.setSeconds(Number(value));
      }

      onChange && onChange({
        isAM,
        value: dateFnsFormat(transformValue, format && format.replace(/(\s+)A/g, '$1a')),
        timeStampValue: Number(transformValue)
      });
    };

    this.onEnterSelectPanel = range => {
      const {
        onCurrentSelectPanelChange
      } = this.props;
      onCurrentSelectPanelChange(range);
    };

    this.getDisplayDateFromTimeStamp = timeStampValue => this.foundation.getDisplayDateFromTimeStamp(timeStampValue);

    this.foundation = new ComboboxFoundation(this.adapter);
    this.state = _Object$assign({}, this.foundation.initData());
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.timeStampValue !== this.props.timeStampValue || prevProps.format !== this.props.format) {
      this.setState(_Object$assign({}, this.foundation.initData()));
    }
  }

  componentWillUnmount() {// this.foundation.destroy();
  }

  componentDidMount() {// this.foundation.init();
  }

  renderHourSelect(hour, locale) {
    const {
      prefixCls,
      disabledHours,
      use12Hours,
      scrollItemProps
    } = this.props;
    const {
      showHour,
      hourOptions
    } = this.state;

    if (!showHour) {
      return null;
    }

    const disabledOptions = disabledHours();
    let hourOptionsAdj, hourAdj;

    if (use12Hours) {
      var _context;

      hourOptionsAdj = _concatInstanceProperty(_context = [12]).call(_context, _filterInstanceProperty(hourOptions).call(hourOptions, h => h < 12 && h > 0));
      hourAdj = hour % 12 || 12;
    } else {
      hourOptionsAdj = hourOptions;
      hourAdj = hour;
    }

    const transformHour = value => value + locale.hour;

    const className = "".concat(prefixCls, "-list-hour");
    return /*#__PURE__*/React.createElement(ScrollItem, _Object$assign({
      ref: current => this.cacheRefCurrent('hour', current),
      mode: 'wheel',
      transform: transformHour,
      cycled: true,
      className: className,
      list: _mapInstanceProperty(hourOptionsAdj).call(hourOptionsAdj, option => formatOption(option, disabledOptions)),
      selectedIndex: _indexOfInstanceProperty(hourOptionsAdj).call(hourOptionsAdj, hourAdj),
      type: "hour",
      onSelect: this.onItemChange
    }, scrollItemProps));
  }

  renderMinuteSelect(minute, locale) {
    const {
      prefixCls,
      disabledMinutes,
      timeStampValue,
      scrollItemProps
    } = this.props;
    const {
      showMinute,
      minuteOptions
    } = this.state;

    if (!showMinute) {
      return null;
    }

    const value = new Date(timeStampValue);
    const disabledOptions = disabledMinutes && disabledMinutes(value.getHours());
    const className = "".concat(prefixCls, "-list-minute");

    const transformMinute = min => min + locale.minute;

    return /*#__PURE__*/React.createElement(ScrollItem, _Object$assign({
      ref: current => this.cacheRefCurrent('minute', current),
      mode: 'wheel',
      transform: transformMinute,
      cycled: true,
      list: _mapInstanceProperty(minuteOptions).call(minuteOptions, option => formatOption(option, disabledOptions)),
      selectedIndex: _indexOfInstanceProperty(minuteOptions).call(minuteOptions, minute),
      type: "minute",
      onSelect: this.onItemChange,
      className: className
    }, scrollItemProps));
  }

  renderSecondSelect(second, locale) {
    const {
      prefixCls,
      disabledSeconds,
      timeStampValue,
      scrollItemProps
    } = this.props;
    const {
      showSecond,
      secondOptions
    } = this.state;

    if (!showSecond) {
      return null;
    }

    const value = new Date(timeStampValue);
    const disabledOptions = disabledSeconds && disabledSeconds(value.getHours(), value.getMinutes());
    const className = "".concat(prefixCls, "-list-second");

    const transformSecond = sec => String(sec) + locale.second;

    return /*#__PURE__*/React.createElement(ScrollItem, _Object$assign({
      ref: current => this.cacheRefCurrent('second', current),
      mode: 'wheel',
      transform: transformSecond,
      cycled: true,
      list: _mapInstanceProperty(secondOptions).call(secondOptions, option => formatOption(option, disabledOptions)),
      selectedIndex: _indexOfInstanceProperty(secondOptions).call(secondOptions, second),
      className: className,
      type: "second",
      onSelect: this.onItemChange
    }, scrollItemProps));
  }

  renderAMPMSelect(locale, localeCode) {
    const {
      prefixCls,
      use12Hours,
      isAM,
      scrollItemProps
    } = this.props;

    if (!use12Hours) {
      return null;
    }

    const AMPMOptions = [{
      value: 'AM',
      text: locale.AM || '上午'
    }, {
      value: 'PM',
      text: locale.PM || '下午'
    }];
    const selected = isAM ? 0 : 1;
    const className = "".concat(prefixCls, "-list-ampm");
    return /*#__PURE__*/React.createElement(ScrollItem, _Object$assign({
      ref: current => this.cacheRefCurrent('ampm', current),
      mode: 'wheel',
      className: className,
      cycled: false,
      list: AMPMOptions,
      selectedIndex: selected,
      type: "ampm",
      onSelect: this.onItemChange
    }, scrollItemProps));
  }

  render() {
    const {
      timeStampValue,
      panelHeader,
      panelFooter
    } = this.props;
    const value = this.getDisplayDateFromTimeStamp(timeStampValue);
    return /*#__PURE__*/React.createElement(LocaleConsumer, {
      componentName: "TimePicker"
    }, (locale, localeCode) => /*#__PURE__*/React.createElement(ScrollList, {
      header: panelHeader,
      footer: panelFooter
    }, this.renderAMPMSelect(locale, localeCode), this.renderHourSelect(value.getHours(), locale), this.renderMinuteSelect(value.getMinutes(), locale), this.renderSecondSelect(value.getSeconds(), locale)));
  }

}

Combobox.propTypes = {
  format: PropTypes.string,
  defaultOpenValue: PropTypes.object,
  prefixCls: PropTypes.string,
  onChange: PropTypes.func,
  showHour: PropTypes.bool,
  showMinute: PropTypes.bool,
  showSecond: PropTypes.bool,
  disabledHours: PropTypes.func,
  disabledMinutes: PropTypes.func,
  disabledSeconds: PropTypes.func,
  hideDisabledOptions: PropTypes.bool,
  onCurrentSelectPanelChange: PropTypes.func,
  use12Hours: PropTypes.bool,
  isAM: PropTypes.bool,
  timeStampValue: PropTypes.any,
  scrollItemProps: PropTypes.object
};
Combobox.defaultProps = {
  disabledHours: _noop,
  disabledMinutes: _noop,
  disabledSeconds: _noop,
  format: strings.DEFAULT_FORMAT
};
export default Combobox;